var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentComponent,{tag:"component",attrs:{"transition":"switch","loading_status":_vm.loading_status,"modul_data":_vm.curent_api_return,"reGetData":_vm.reGetData,"getFiletrField":_vm.getFiletrField,"setFiletrField":_vm.setFiletrField,"pushRouter":_vm.pushRouter,"curent_right_return":_vm.curent_right_return}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }